// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3065":"260b64bf","29259":"d457bd00","29503":"00da3fca","46607":"0c1e87f5","61436":"f0b69e3b","66846":"a1da6f06","69838":"563e1be2"}[chunkId] + ".chunk.css";
};